"use strict";

var _objectDestructuringEmpty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshToken = exports.resetPassword = exports.forgetPassword = exports.signOut = exports.signIn = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _services = require("../services");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var signIn = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, url) {
    var _result$data, _result$data$login, _result$data2, _result$data2$login, _result$data2$login$u, email, password, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            email = _ref.email, password = _ref.password;
            _context.next = 3;
            return _services.authServices.signIn({
              email: email,
              password: password
            }, url);

          case 3:
            result = _context.sent;

            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data$login = _result$data.login) !== null && _result$data$login !== void 0 && _result$data$login.authToken && result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && (_result$data2$login = _result$data2.login) !== null && _result$data2$login !== void 0 && (_result$data2$login$u = _result$data2$login.user) !== null && _result$data2$login$u !== void 0 && _result$data2$login$u.capabilities.includes('edit_posts')) {
              _utils.auth.setUser(result.data.login);
            }

            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function signIn(_x, _x2) {
    return _ref6.apply(this, arguments);
  };
}();

exports.signIn = signIn;

var signOut = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch) {
    var callback;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            callback = _ref2.callback;

            _utils.auth.logout(callback);

            dispatch({
              type: "REMOVE_AUTH_USER"
            });

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function signOut(_x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}();

exports.signOut = signOut;

var forgetPassword = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, url) {
    var email, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            email = _ref3.email;
            _context3.next = 3;
            return _services.authServices.forgetPassword({
              email: email
            }, url);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function forgetPassword(_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}();

exports.forgetPassword = forgetPassword;

var resetPassword = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, url) {
    var key, login, password, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            key = _ref4.key, login = _ref4.login, password = _ref4.password;
            _context4.next = 3;
            return _services.authServices.resetPassword({
              key: key,
              login: login,
              password: password
            }, url);

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function resetPassword(_x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}();

exports.resetPassword = resetPassword;

var refreshToken = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, config) {
    var _utils$auth$getUser, refreshToken, _result$data3, result;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _objectDestructuringEmpty(_ref5);

            _utils$auth$getUser = _utils.auth.getUser(), refreshToken = _utils$auth$getUser.refreshToken;

            if (!refreshToken) {
              _context5.next = 8;
              break;
            }

            _context5.next = 5;
            return _services.authServices.refreshToken({
              refreshToken: refreshToken
            }, config.source);

          case 5:
            result = _context5.sent;

            if (result !== null && result !== void 0 && (_result$data3 = result.data) !== null && _result$data3 !== void 0 && _result$data3.refreshJwtAuthToken) {
              _utils.auth.setUser(_objectSpread({
                refreshToken: refreshToken
              }, result.data.refreshJwtAuthToken));
            }

            return _context5.abrupt("return", result);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function refreshToken(_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}();

exports.refreshToken = refreshToken;